import React from "react";

const Contact = () => (
<section id="contact">
    <div className="container text-center">
      <div className="title-block">
        <p>Do you have any questions about the National Data Science Challenge?</p>
        <a href="mailto:NDSC@shopee.com" className="btn btn-primary">Contact Us</a>
        <p style={{marginTop: "40px"}}>For partnership opportunities on tech related events, please email to: <a href="mailto:techsg@shopee.com">techsg@shopee.com</a></p>
      </div>
    </div>
  </section>
);

export default Contact;